import React, { Component } from "react";
import {
    FormGroup,
    FormControl,
    Button,
    Alert,
    Checkbox,
    Badge
} from "react-bootstrap";
import { browserHistory } from "react-router";

import axios from "axios";

class SignupForm extends Component {
    /**
   * Class constructor.
   */
    constructor(props) {
        super(props);

        // set the initial component state
        this.state = {
            user: {
                email: "",
                password: "",
                firstName: "",
                lastName: "",
                terms: false
            },
            error: "",
            submitting: false
        };

        this.processForm = this.processForm.bind(this);
        this.changeUser = this.changeUser.bind(this);
    }

    processForm(event) {
        event.preventDefault();

        const requestData = {
            login: this.state.user.email,
            email: this.state.user.email,
            password: this.state.user.password,
            firstName: this.state.user.firstName,
            lastName: this.state.user.lastName
        };

        if (!this.validateEmail(requestData.email)) {
            this.setState({ error: "Not a valid email address" });
        } else if (!requestData.firstName) {
            this.setState({
                error: "What's your first name?"
            });
        } else if (!requestData.lastName) {
            this.setState({
                error: "What's your last name?"
            });
        } else if (
            !requestData.password ||
            requestData.password.length < 4 ||
            requestData.password.length > 100
        ) {
            this.setState({
                error: "Choose password between 4 and 100 characters"
            });
        } else if (!this.state.user.terms) {
            this.setState({ error: "Agreeing to the terms is obligatory" });
        } else
            this.sendSignupRequest(requestData);
    }

    validateEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    sendSignupRequest(requestData) {
        this.setState({ submitting: true });
        let that = this;
        axios
            .post("/api/register", requestData)
            .then(function(response) {
                browserHistory.push("/signup/pending");
                //Almost done! Activation required, please click the link in the email we sent you.
                that.setState({ submitting: false });
            })
            .catch(function(error) {
                that.setState({ submitting: false });
                if (
                    error.response.status === 400 &&
                    error.response.data === "login already in use"
                ) {
                    that.setState({ error: "This login is already in use" });
                } else if (
                    error.response.status === 400 &&
                    error.response.data === "email address already in use"
                ) {
                    that.setState({
                        error: "This email address is already in use"
                    });
                } else {
                    that.setState({ error: "There was an error" });
                }
            });
    }

    changeUser(event) {
        const field = event.target.name;
        const user = this.state.user;

        let newValue = event.target.type === "checkbox"
            ? event.target.checked
            : event.target.value;

        user[field] = newValue;

        this.setState({
            user: user
        });
    }

    render() {
        const errors = this.state.error
            ? <Alert bsStyle="danger">{this.state.error}</Alert>
            : <Alert />;

        const submitLabel = this.state.submitting ? "Submitting..." : "Sign up";

        return (
            <div>
                <form
                    className="login-form"
                    action="/"
                    onSubmit={this.processForm}
                >

                    <h1>Sign up</h1>
                    <h2><Badge style={{'background':'#0A79D3'}}>Create Free Account</Badge></h2>                    

                    <FormGroup>
                        {errors}
                    </FormGroup>

                    <FormGroup>
                        <FormControl
                            type="text"
                            placeholder="Email"
                            value={this.state.user.email}
                            onChange={this.changeUser}
                            name="email"
                        />
                    </FormGroup>
                    <FormGroup>
                        <FormControl
                            type="text"
                            placeholder="First name"
                            value={this.state.user.firstName}
                            onChange={this.changeUser}
                            name="firstName"
                        />
                    </FormGroup>
                    <FormGroup>
                        <FormControl
                            type="text"
                            placeholder="Last name"
                            value={this.state.user.lastName}
                            onChange={this.changeUser}
                            name="lastName"
                        />
                    </FormGroup>
                    <FormGroup>
                        <FormControl
                            type="password"
                            placeholder="Password"
                            value={this.state.user.password}
                            onChange={this.changeUser}
                            name="password"
                        />
                    </FormGroup>
                    <FormGroup>
                        <Checkbox
                            inline
                            checked={this.state.user.terms}
                            onChange={this.changeUser}
                            name="terms"
                        >
                            I agree to the terms
                        </Checkbox>
                    </FormGroup>
                    <FormGroup>
                        <Button
                            disabled={this.state.submitting}
                            type="submit"
                            bsStyle="success"
                        >
                            {submitLabel}
                        </Button>
                    </FormGroup>

                </form>
            </div>
        );
    }
}

export default SignupForm;



// WEBPACK FOOTER //
// ./src/signup/SignupForm.js